import ModelingListContext from './context';

const useModelingListContext = () => ModelingListContext.hook();

export default useModelingListContext;
